module.exports = __webpack_public_path__ + "img/danger-icon.7b95562f.svg";